import React from 'react'
import Layout from '../../../components/layout/Layout'
import { StateOfAgents } from '../../../components/labs/state-of-agents'
import { SectionTitle } from '@multiagentbook/ui'
import { ToolsNav } from '../../../components/pages/nav'

const siteMetadata = {
  description:
    'Analysis of 5,622 Y Combinator companies. 1,750 are AI companies, 765 (13.6%) are building AI agents. Classification via multi-agent workflow.',
  title: 'State of AI Agents - YC Startup Analysis',
  author: 'Victor Dibia',
  image: '/images/og-card.png',
  keywords:
    'yc startups, ai agents, y combinator, startup analysis, multi-agent systems, autonomous ai, visualization',
  twitterUsername: '@designingwithml',
}

const breadcrumbPages = [
  { name: 'Labs', href: '/labs', current: false },
  { name: 'State of AI Agents', href: '/labs/state-of-agents', current: true },
]

const StateOfAgentsPage: React.FC = () => {
  return (
    <Layout
      meta={siteMetadata}
      title="State of AI Agents"
      link="/labs/state-of-agents"
    >
      <main>
        {/* Breadcrumbs */}
        <ToolsNav pages={breadcrumbPages} />

        {/* Hero Section */}
        <div className="mb-8 mt-6">
          <SectionTitle title="State of AI Agents" />
          <p className="text-lg text-secondary mt-2 max-w-3xl">
            Analysis of 5,622 Y Combinator companies from 2005-2025. Of these,
            1,750 are AI companies and 765 (13.6%) are building AI agents.
            Classification performed using a multi-agent workflow.
          </p>
        </div>

        {/* Main Component */}
        <StateOfAgents />
      </main>
    </Layout>
  )
}

export default StateOfAgentsPage
